import { c as _c } from "react/compiler-runtime";
import { IcoArrowUpRight16 } from '@onefootprint/icons';
import type { ApiNodeDataTaktile, NodeExecutionDetailTaktile } from '@onefootprint/request-types/dashboard';
import { CodeBlock, CodeInline, LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { useGetTraceContext } from '../../hooks/use-get-trace-context';
import type { NodeProps } from '../../playbook-builder.types';
import Section from '../section';
type DrawerContentProps = {
  node: NodeProps<ApiNodeDataTaktile>;
};
const DrawerContent = t0 => {
  const $ = _c(47);
  const {
    node
  } = t0;
  const {
    id,
    data
  } = node;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "taktile"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const trace = useGetTraceContext(id, "taktile");
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="text-body-2 text-tertiary">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = data.flowSlug || "\u2014";
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="text-body-2 text-right flex-1">{t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <div className="flex gap-5 justify-between items-start">{t4}{t6}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t(_temp3);
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <div className="text-body-2 text-tertiary">{t8}</div>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = data.flowVersion || "\u2014";
  let t11;
  if ($[16] !== t10) {
    t11 = <div className="text-body-2 text-right flex-1">{t10}</div>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t9) {
    t12 = <div className="flex gap-5 justify-between items-start">{t9}{t11}</div>;
    $[18] = t11;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t(_temp4);
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = <div className="text-body-2 text-tertiary">{t13}</div>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== data.environment) {
    t15 = $_3 => $_3.form.environment[data.environment];
    $[25] = data.environment;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t || $[28] !== t15) {
    t16 = t(t15);
    $[27] = t;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16) {
    t17 = <div className="text-body-2 text-right flex-1">{t16}</div>;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t14 || $[33] !== t17) {
    t18 = <div className="flex gap-5 justify-between items-start">{t14}{t17}</div>;
    $[32] = t14;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t12 || $[36] !== t18 || $[37] !== t7) {
    t19 = <div className="flex flex-col gap-4">{t7}{t12}{t18}</div>;
    $[35] = t12;
    $[36] = t18;
    $[37] = t7;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t19 || $[40] !== t2) {
    t20 = <Section title={t2}>{t19}</Section>;
    $[39] = t19;
    $[40] = t2;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== trace) {
    t21 = trace?.context && trace.context.kind === "taktile" && <TraceView context={trace.context} />;
    $[42] = trace;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t20 || $[45] !== t21) {
    t22 = <div className="flex flex-col gap-4">{t20}{t21}</div>;
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  return t22;
};
type TraceViewProps = {
  context: NodeExecutionDetailTaktile;
};
const TraceView = t0 => {
  const $ = _c(13);
  const {
    context: t1
  } = t0;
  const {
    decisionUrl: t2,
    decisionId: t3,
    output: t4
  } = t1;
  const decisionUrl = t2 === undefined ? "" : t2;
  const decisionId = t3 === undefined ? "" : t3;
  let t5;
  if ($[0] !== t4) {
    t5 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const output = t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      keyPrefix: "taktile"
    };
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const {
    t
  } = useTranslation("playbook-builder", t6);
  let t7;
  if ($[3] !== decisionId || $[4] !== decisionUrl || $[5] !== t) {
    t7 = (decisionUrl || decisionId) && <Section title={t(_temp5)}><div className="space-y-3">{decisionUrl && <div className="flex gap-5 justify-between items-start"><div className="text-body-2 text-tertiary">{t(_temp6)}</div><LinkButton href={decisionUrl} target="_blank" iconComponent={IcoArrowUpRight16}>View in Taktile</LinkButton></div>}{decisionId && <div className="flex flex-col gap-1 md:flex-row md:gap-5 md:justify-between md:items-start"><div className="text-body-2 text-tertiary">{t(_temp7)}</div><CodeInline>{decisionId}</CodeInline></div>}</div></Section>;
    $[3] = decisionId;
    $[4] = decisionUrl;
    $[5] = t;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== output || $[8] !== t) {
    t8 = Object.keys(output).length > 0 && <CodeBlock title={t(_temp8)} language="json">{JSON.stringify(output, null, 2)}</CodeBlock>;
    $[7] = output;
    $[8] = t;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};
export default DrawerContent;
function _temp($) {
  return $.configuration;
}
function _temp2($_0) {
  return $_0.form.flowSlugLabel;
}
function _temp3($_1) {
  return $_1.form.flowVersion;
}
function _temp4($_2) {
  return $_2.form.environmentLabel;
}
function _temp5($) {
  return $.form.resultsTitle;
}
function _temp6($_0) {
  return $_0.form.decision;
}
function _temp7($_1) {
  return $_1.form.decisionId;
}
function _temp8($_2) {
  return $_2.form.rawOutput;
}